import { createContext, useContext, useState } from "react";

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [questionIdCounter, setQuestionIdCounter] = useState(1);
  const [formData, setFormData] = useState({
    formName: "",
    canFillAtHome: false,
  });

  const [tabs, setTabs] = useState([
    { id: "tab1", label: "Page 1", content: [] },
  ]);
  const updateFormData = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <FormContext.Provider
      value={{
        formData,
        updateFormData,
        questionIdCounter,
        setQuestionIdCounter,
        tabs,
        setTabs,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useForm = () => useContext(FormContext);
